import { isDevPc } from '../../sharedF/isDevPcF.mts';
import './betLogGamesFormattersAI.mjs';
export const gameDrawDims = { width: 600, height: 600 };
export const minNoPlayers = 4;
export const showAiCost = isDevPc;
